<template>
  <div>
    <div cols="12">
        <img class="mr-2" src="/static-appopensalud/img/icons/creditcard-grey.svg" height="30" width="30" />
        <h4 class="payment-title" v-html="$t('payments.payment')"></h4>
    </div>
    <hr>
    <b-row class="mb-3" v-if="showPriceBlock">
        <b-col cols="12" md="6">
            <div><label v-html="$t('payments.price')"></label>: <span :class="{'line-through': discountApplied}" v-html="`${price} ${currency}`"></span></div>
            <div v-if="discountApplied"><label v-html="$t('payments.discount')"></label>: <span v-html="`${discountApplied} %`"></span></div>
            <div v-if="discountApplied"><label v-html="$t('payments.priceWithDiscount')"></label>: <span v-html="finalPriceText"></span></div>
        </b-col>
        <b-col class="promotion-code-block" cols="12" md="6">
            <a v-if="showPromotionCodeQuestion" href="" @click.prevent="showPromotionCodeQuestion = false" v-html="$t('payments.couponQuestion')"></a>
            <div v-if="!showPromotionCodeQuestion"><base-input class="promotion-code-input" v-model="promotionCode" :placeholder="$t('payments.discountCoupon')"></base-input> <base-button @click="checkPromotionCode">{{$t('payments.verify')}}</base-button></div>
        </b-col>
    </b-row>
    <!--TODO: Not finished. Fill in when necessary comparing with 'paytpv-template.html'-->
    <form class="payment-block" v-show="showCreditCardForm" id="openpayPaymentForm">
        <b-row>
            <b-col cols="12">
                <label v-html="$t('payments.cardnumber')"></label>
                <base-input v-model="creditCardData.cardNumber"></base-input>
                <base-input v-show="false" v-model="creditCardData.sanitizedCardNumber" :dataAttributes="{'data-openpay-card': 'card_number'}"></base-input>
            </b-col>
            <b-col cols="12" md="3">
                <label v-html="$t('payments.expiration')"></label>
                <base-select v-model="creditCardData.month" :options="months" :placeholder="$t('month')" label="text"></base-select>
                <base-input v-show="false" v-model="creditCardData.month" :dataAttributes="{'data-openpay-card': 'expiration_month'}"></base-input>
            </b-col>
            <b-col class="mb-4" cols="12" md="3" offset-md="1">
                <label class="hidden" v-html="$t('payments.year')"></label>
                <base-select v-model="creditCardData.year" :options="years" :placeholder="$t('year')" label="text"></base-select>
                <base-input v-show="false" v-model="creditCardData.year" :dataAttributes="{'data-openpay-card': 'expiration_year'}"></base-input>
            </b-col>
            <b-col cols="12" md="3" offset-md="2">
                <label v-html="$t('payments.cvv')"></label>
                <base-input :type="cvvInputType" v-model="creditCardData.cvv" @keyup="cvvChange" :maxlength="4" autocomplete="off" :dataAttributes="{'data-openpay-card': 'cvv2'}"></base-input>
            </b-col>
            <b-col cols="12">
                <label v-html="$t('payments.holdername')"></label>
                <base-input v-model="creditCardData.holderName" :dataAttributes="{'data-openpay-card': 'holder_name'}"></base-input>
            </b-col>
        </b-row>
    </form>
    <div>
        <b-row>
            <b-col cols="12">
                <base-checkbox v-model="termsAccepted">
                    <span v-html="$t('signupOH.accept-terms-patient')"></span>
                </base-checkbox>
            </b-col>
        </b-row>
        <b-row class="mt-5">
            <b-col cols="12" class="text-center">
                <back-button withoutArrow :action="() => $emit('back')" class="mr-3"></back-button> <base-button @click="payAction">{{ payBtnTitle }}</base-button>
            </b-col>
        </b-row>
    </div>
    <base-dialog :value="showEPrescriptionAvailableDialog" :okFn="() => { sendPaymentData() }" :okBtnText="$t('confirm')" :cancelBtnText="$t('cancel')" :cancelFn="() => closeModalAndReload()" :content="$t('payments.ePrescriptionTax')"></base-dialog>
  </div>
</template>

<script>
import BaseButton from '../base/buttons/BaseButton'
import BackButton from '../base/buttons/BackButton'
import BaseDialog from '@/components/base/BaseDialog'
import { inProductionEnv } from '@/helpers/global.helpers'
import { CHANGE_PAYMENT_METHOD, APPOINTMENT_ERROR, PENDING_PAYMENT } from '@/constants/paymentTypes'
import paymentsRepository from '@/repositories/PaymentsRepository'
import { getCurrencyByDomain } from '@/constants/currencies'
import { OPENPAY_API_KEY, OPENPAY_ID } from '@/constants/vendorKeys'
import { BFormGroup, BFormRadio } from 'bootstrap-vue'
import { loadScript } from 'vue-plugin-load-script'
import paymentsMixin from '@/mixins/payments.mixin'

export default {
    components: {
        BaseButton,
        BackButton,
        BFormGroup,
        BFormRadio,
        BaseDialog
    },
    props: {
        price: Number,
        paymentType: Number,
        appointmentId: Number,
        servicesPackageId: String,
        copayment: Boolean,
        ePrescriptionAvailable: Boolean
    },
    computed: {
        payBtnTitle () {
            return this.freeService ? this.$t('continue') : this.$t('payments.confirmPayment')
        },
        currency () {
            return getCurrencyByDomain()
        },
        freeService () {
            return this.discountApplied === 100
        },
        months () {
            let months = []
            for (let i = 1; i <= 12; i++) {
                let value = i.toString().padStart(2, '0')
                months.push({ text: value, value: value })
            }
            return months
        },
        years () {
            let years = []
            let currentYear = parseInt(new Date().getFullYear().toString())
            for (let i = currentYear; i <= currentYear + 20; i++) {
                years.push({ text: i.toString(), value: i.toString().substring(2) })
            }
            return years
        },
        showPriceBlock () {
            return this.paymentType !== CHANGE_PAYMENT_METHOD
        },
        finalPrice () {
            return this.discountApplied ? parseFloat(this.price - (this.price * (this.discountApplied / 100))).toFixed(2) : this.price
        },
        finalPriceText () {
            return this.finalPrice > 0 ? `${this.finalPrice} ${this.currency}` : this.$t('payments.free')
        }
    },
    mounted () {
        loadScript('https://openpay.s3.amazonaws.com/openpay.v1.min.js').then(() => {
            loadScript('https://openpay.s3.amazonaws.com/openpay-data.v1.min.js').then(() => {
                /* eslint-disable no-undef */
                OpenPay.setId(OPENPAY_ID)
                OpenPay.setApiKey(OPENPAY_API_KEY)
                OpenPay.setSandboxMode(!inProductionEnv)
                this.paymentData.deviceSessionId = OpenPay.deviceData.setup('openpayPaymentForm', 'deviceIdHiddenFieldName')
            })
        })
    },
    mixins: [paymentsMixin],
    data () {
      return {
        showCreditCardForm: true,
        paymentData: {
            token: null,
            holderName: null,
            customerId: null,
            deviceSessionId: null,
            titular: null,
            profId: null,
            centerId: null,
            slotType: null,
            isFirstAppointment: null,
            appointmentId: this.appointmentId,
            idRateRanges: null,
            transactionType: this.transactionType
        }
      }
    },
    methods: {
        payAction () {
            if (!this.termsAccepted) {
                this.$store.dispatch('showInfoAlert', this.$t('payments.acceptTerms'))
            } else if (this.freeService && this.appointmentId) {
                this.applyFullDiscount()
            } else {
                this.pay()
            }
        },
        pay () {
            if (!this.creditCardData.holderName) {
                this.$store.dispatch('showInfoAlert', this.$t('payments.enterHolderName'))
            } else if (!this.creditCardData.cardNumber) {
                this.$store.dispatch('showInfoAlert', this.$t('payments.enterCardNumber'))
            } else if (!this.creditCardData.month) {
                this.$store.dispatch('showInfoAlert', this.$t('payments.selectMonth'))
            } else if (!this.creditCardData.year) {
                this.$store.dispatch('showInfoAlert', this.$t('payments.selectYear'))
            } else if (!this.creditCardData.cvv) {
                this.$store.dispatch('showInfoAlert', this.$t('payments.enterCvv'))
            } else {
                OpenPay.token.extractFormAndCreate('openpayPaymentForm', (successResponse) => {
                    this.paymentData.token = successResponse.data.id
                    this.paymentData.holderName = this.creditCardData.holderName
                    if ((this.paymentType === PENDING_PAYMENT || this.paymentType === APPOINTMENT_ERROR) && this.appointmentId) {
                        this.sendPaymentData()
                    } else {
                        this.createOpenpayUser()
                    }
                }, (errorResponse) => {
                    this.$store.dispatch('showDangerAlert', errorResponse.data.description !== undefined ? errorResponse.data.description : errorResponse.message)
                })
            }
        },
        createOpenpayUser () {
            // TODO: fill when necessary
        },
        sendPaymentData () {
            paymentsRepository.sendOpenpayPayment(this.paymentData).then((result) => {
                if (!result.data.data) {
                    this.$store.dispatch('showDangerAlert', this.$t('defaultErrorMessage'))
                } else {
                    this.$store.dispatch('showSuccessAlert', this.$t('defaultSuccessMessage'))
                    this.closeModalAndReload()
                }
            })
        }
    }
}
</script>

<style scoped lang="scss">
@import '../../../static-appopensalud/css/webapp/payments.scss';
</style>


// WEBPACK FOOTER //
// src/components/payment/OpenpayPayment.vue